/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListinoCreateDTO
 */
export interface ListinoCreateDTO {
    /**
     * 
     * @type {number}
     * @memberof ListinoCreateDTO
     */
    idFiliera?: number;
    /**
     * 
     * @type {number}
     * @memberof ListinoCreateDTO
     */
    idAnagrafe?: number | null;
}

/**
 * Check if a given object implements the ListinoCreateDTO interface.
 */
export function instanceOfListinoCreateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListinoCreateDTOFromJSON(json: any): ListinoCreateDTO {
    return ListinoCreateDTOFromJSONTyped(json, false);
}

export function ListinoCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListinoCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idFiliera': !exists(json, 'idFiliera') ? undefined : json['idFiliera'],
        'idAnagrafe': !exists(json, 'idAnagrafe') ? undefined : json['idAnagrafe'],
    };
}

export function ListinoCreateDTOToJSON(value?: ListinoCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idFiliera': value.idFiliera,
        'idAnagrafe': value.idAnagrafe,
    };
}

